/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import RefreshIcon from "@mui/icons-material/Refresh";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import LoadingModal from "../../components/LoadingModel/loadingModal";
import { downloadQuotation } from "utils/quotationAPI";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { BTable } from "components/BTable/BTable";
import BillingModal from "components/displayModel/billingModel";
import { useDispatch, useSelector } from 'react-redux';
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import styled from 'styled-components';
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Email as EmailIcon,
  ContentCopy as ContentCopyIcon,
  Download as DownloadIcon,
  Delete as DeleteIcon,
  Receipt as ReceiptIcon,
  ContactsOutlined
} from '@mui/icons-material';
import IconMenu from "components/CustomMaterialMenu/Custom";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import SearchField from "components/SearchField/SearchField";
import { set } from "date-fns";
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { toast } from "react-toastify";
import { blank } from "utils/generic";
import { formatCurrencyAUD } from "utils/formatCurrency";

const SCREEN_NAME = "Quotations";
let SCREEN_RIGHT;

const CustomIconButton = styled(IconButton)`
  .MuiSvgIcon-root {
   color:  ${({ tableBorder, darkMode }) => darkMode ? "white" : tableBorder};
  }
`;

function QuotaionsSearch() {
  const [resetClicked, setResetClicked] = useState(false);
  let currency = useSelector((state) => state.currency.currencySymbol);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [title, setTitle] = useState("");
  const dispatch = useDispatch()
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = useState({
    _id: [],
    businessUserID: loginDetails?.businessUserID,
    // contactID: '',
    sortingType: "",
    sortingField: "",
    quotationStatus: "All",
    activityStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    sendEmailFlag: false,
    filterValues: "",
    searchParameterList: ['quotationNumber', 'activityStatus', 'quotationStatus', 'createdInvoice', 'quotationDate', 'customerName',
      'unitOfMeasurement', 'finalAmount', 'lastEmailSentDate', 'customerCompanyName', 'purchaseOrderNumber'],
  });

  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    selectedID: '',
    screenType: "Quotation",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        let duration = new URLSearchParams(window.location.search).get('duration');
        let customFrom = new URLSearchParams(window.location.search).get('from');
        let customTo = new URLSearchParams(window.location.search).get('to');
        duration && (values.durationDate = duration)
        customFrom && (values.fromDate = customFrom)
        customTo && (values.toDate = customTo)
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await fetchQuotations();
        sessionStorage.removeItem("HoldQuotationData");
        sessionStorage.removeItem("deletedItems");

      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, [values.quotationStatus, values.activityStatus, perPage]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    console.log("SCREEN_RIGHT", SCREEN_RIGHT)
    setScreenAccess(SCREEN_RIGHT === 'Full Access');
  }

  const fetchQuotations = useCallback(async () => {
    setLoading(true);
    values.perPage = perPage;
    values.token = loginDetails.token;
    await axios.post(appConstants.baseURL + 'quotation/fetchQuotations', values)
      .then(
        (res) => {
          console.log("fetchQuotations res", res);
          setRows(res.data.Result_Output.docs);
          setTotalRows(res.data.Result_Output.totalDocs);
          setLoading(false);
        }
      )
      .catch(
        (error) => {
          setLoading(false);
          console.log("Error in fetchQuotations=", error.message)
        }
      );
  }, [values, perPage, values.sortingType])

  const handleDeleteDialogeClick = async (value) => {
    values._id = value;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  // const handleResendEmail = async (selectedRow) => {
  //   ShowSwalWithButtons(
  //     'Are you sure?', `Would you like to ${selectedRow.emailSent > 0 ? "Resend" : "Send"} Email?`, 'warning', darkMode,
  //     () => {

  // dispatch(loadingAction(true));
  // let payload = { businessUserID: values.businessUserID, quotationID: selectedRow._id }
  // axios.post(appConstants.baseURL + "quotation/resendEmail", payload).then(res => {
  //   dispatch(loadingAction(false));
  //   let status = res.data.Result_Status;
  //   showResMsg(res.data.Result_Message, 2000, status);
  // }).catch(error => {
  //   dispatch(loadingAction(false));
  //   console.log("Error in ResendEmail", error);
  // })
  //     }
  //   );
  // }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {

    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
    };
    dispatch(loadingAction(true));
    console.log("payload", payload)
    axios.post(appConstants.baseURL + "quotation/resendEmail", payload).then(res => {
      dispatch(loadingAction(false));
      let status = res.data.Result_Status;
      showResMsg(res.data.Result_Message, 2000, status);
      fetchQuotations();
    }).catch(error => {
      dispatch(loadingAction(false));
      console.log("Error in ResendEmail", error);
    })
    values.sendEmailFlag = true;
    values.templateValues = payload;
    setOpen(false)
  }

  const handleResendEmail = async (selectedRow) => {
    if (!selectedRow.finalAmount || selectedRow.finalAmount <= 0) {
      toast.error("No item added");
    } else {
      if (AllKeysHaveValue(templateValues)) {
        setOpen(true);
      } else {
        await getEmailAndTemplateForQuotation({
          screenType: templateValues.screenType, contactID: selectedRow.contactID, quotationID: selectedRow._id, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "")
        }, (data) => {
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg(data.Result_Message, 2000, false);
            setOpen(false);
          }
        }, dispatch);
      }
    }
  }

  const handleCloneQuotation = async (id, quotationNo) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to clone the Quotation ${quotationNo}?`, 'warning', darkMode,
      () => {
        dispatch(loadingAction(true));
        let payload = { businessUserID: values.businessUserID, quotationID: id, userID: loginDetails?._id, }
        axios.post(appConstants.baseURL + "quotation/cloneQuotation", payload,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
        ).then(res => {
          dispatch(loadingAction(false));
          let status = res.data.Result_Status;

          if (res.data.Result_Output === "NO AVAILABLE CREDITS") {
            setShowBillingModal(true);

          } else {
            showResMsg(res.data.Result_Message, 2000, status, navigate, status === true ? `/quotations/edit/${res.data.Result_Output._id}` : "");
          }
        }).catch(error => {
          dispatch(loadingAction(false));
          console.log("Error in cloneQuotation", error);
        })
      }
    );

  }
  const handleCreateInvoice = async (id, quotationNo) => {
    console.log("dsssss", id, quotationNo)
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to create the Invoice with the details of Quotation ${quotationNo}?`, 'warning', darkMode,
      () => {
        dispatch(loadingAction(true));
        let payload = { businessUserID: values.businessUserID, quotationID: id, userID: loginDetails?._id, }
        console.log("payload", payload)
        axios.post(appConstants.baseURL + "quotation/createInvoice", payload,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
        ).then(res => {
          dispatch(loadingAction(false));
          let status = res.data.Result_Status;
          if (res.data.Result_Output === "NO AVAILABLE CREDITS") {
            setShowBillingModal(true);
          } else {
            showResMsg(res.data.Result_Message, 2000, status, navigate, status === true ? `/invoices/edit/${res.data.Result_Output._id}` : "");
          }
        }).catch(error => {
          dispatch(loadingAction(false));
          console.log("Error in created Invoices:", error);
        })
      }
    );
  }
  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteQuotation();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteQuotation = async () => {
    try {
      setLoading(true);
      values.token = loginDetails.token;
      console.log("Quotation Token:", loginDetails.token,)
      await axios
        .post(appConstants.baseURL + "quotation/deleteQuotation", values)
        .then((res) => {
          let response = res.data;
          console.log("response", response)
          if (response.Result_Status) {
            fetchQuotations();
            setToggleCleared(true);
            setTitle("");
            showResMsg(genericMessage.deleted, 1000, res.data.Result_Status);
          } else {
            setLoading(false);
            showResMsg(response.Result_Message, 2000, false)
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteQuotation API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteQuotation API=", error);
    }
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = async (column, sortDirection) => {
    values.sortingField = column;
    values.sortingType = sortDirection;
    await fetchQuotations();
  };

  const handlePageChange = page => {
    values.page = page;
    fetchQuotations();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>Quotation Number</p>,
      selector: row => (
        <div>
          <Tooltip title={`View ${row.quotationNumber}`}>
            <Link to={`/quotations/view/${row._id}`} style={{ fontSize: "12px", color: tableBorder, fontWeight: '600' }}>
              <span className="textUnderline">{row.quotationNumber}</span></Link>
          </Tooltip>
        </div >),
      sortable: true,
      sortField: 'quotationNumber',
      minWidth: '120px'

    },
    {
      name: <p style={{ fontSize: "12px", textAlign: "left" }}>Customer Name</p>,
      selector: row => (
        <span style={{ fontSize: "12px", textAlign: "left" }}>{row.customerCompanyName}</span>
      ),
      sortable: true,
      sortField: 'customerCompanyName',
      left: 'true',
      minWidth: '140px'
    },
    {
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Quotation Date</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.quotationDate}</span>
      ),
      sortable: true,
      sortField: 'quotationDate',
      center: 'true',
      minWidth: '160px'
    },
    {
      name: <p style={{ paddingLeft: "0px", fontSize: "12px" }}>Reference Number</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.purchaseOrderNumber}</span>
      ),
      sortable: true,
      sortField: 'purchaseOrderNumber',
      left: 'true',
      minWidth: '100px'
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>{`Created Invoice`}</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.createdInvoice}</span>
      ),
      sortable: true,
      sortField: 'createdInvoice',
      center: 'true',
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Last Email Sent</p>,
      selector: row => (
        <Tooltip title={`${row.emailSent} Email(s) sent so far`}><span style={{ fontSize: "12px", cursor: "pointer", textDecoration: "underline" }}>{row.lastEmailSentDate}</span></Tooltip>
      ),
      sortable: true,
      sortField: 'lastEmailSentDate',
      center: 'true',
      minWidth: '150px'
    },
    // {
    //   name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Status</p>,
    //   selector: row => (
    //     <span style={{ fontSize: "12px" }}>{row.quotationStatus}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'quotationStatus',
    //   center: 'true',
    // }

    {
      name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}>Status</p>,
      selector: row => row.quotationStatus,
      sortable: true,
      sortField: "quotationStatus",
      center: true,
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.quotationStatus || "N/A"}
        </span>
      )
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>{`Amount (${currency})`}</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.finalAmount)}</span>
      ),

      sortable: true,
      sortField: 'finalAmount',
      center: 'true',
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Activity Status</p>,
      selector: row => (<span style={{ fontSize: "12px", color: darkMode ? "#18e144" : "green" }}>{row.activityStatus}</span>),
      sortable: true,
      sortField: 'activityStatus',
      center: 'true',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      selector: row => row._id,
      cell: row => <IconMenu size="small" row={
        <>
          <Grid style={{ width: "100%" }}>
            {row.quotationStatus === "Pending" ?
              <Link to={`/quotations/edit/${row._id}`} disabled={!screenAccess}>
                <p style={darkMode ? { color: "white" } : { color: "black" }}><TimelineItem color="success"
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
              </Link>
              :
              <p style={darkMode ? { color: "white", cursor: "not-allowed" } : { color: "black", cursor: "not-allowed" }} disabled={!screenAccess} ><TimelineItem color="secondary"
                icon={<EditIcon className="actionicon" />}
                title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            }
          </Grid>
          <Grid style={{ width: "100%" }}>
            <Link to={`/quotations/view/${row._id}`} >
              <p style={darkMode ? { color: "white" } : { color: "black" }} ><TimelineItem color="info"
                icon={<VisibilityIcon className="actionicon" />}
                title="View & History" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;View & History</p>
            </Link></Grid>
          <Grid style={{ width: "100%" }}>
            {row.quotationStatus === "Pending" && row.activityStatus === "Draft" ?
              <p onClick={() => handleDeleteDialogeClick(row._id)} disabled={!screenAccess}><TimelineItem color="success"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row._id)} title="Delete" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
              :
              <p style={{ cursor: "not-allowed" }} disabled={!screenAccess}><TimelineItem color="grey"
                icon={<DeleteIcon className="actionicon" />}
                title="Delete" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
            }</Grid>

          <Grid >
            {row.quotationStatus === "Pending" ?
              <p onClick={() => handleResendEmail(row)} disabled={!screenAccess}> <TimelineItem color="info"
                icon={<EmailIcon className="actionicon" />}
                title={row.emailSent > 0 ? "Resend Email" : "Send Email"} onClick={() => handleResendEmail(row)} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row.emailSent > 0 ? "Resend Email" : "Send Email"}</p>

              :
              <p style={{ cursor: "not-allowed" }} disabled={!screenAccess}><TimelineItem color="grey"
                icon={<EmailIcon className="actionicon" />}
                title="Resend Email" style={{ cursor: "not-allowed" }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Resend Email</p>

            }</Grid>
          <Grid >
            <p onClick={() => { handleCloneQuotation(row._id, row.quotationNumber) }} disabled={!screenAccess}><TimelineItem color="warning"
              icon={<ContentCopyIcon className="actionicon" />}
              title=" Clone Quotation" onClick={() => { handleCloneQuotation(row._id, row.quotationNumber) }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clone Quotation</p>

          </Grid>
          <Grid style={{ width: "100%" }}>
            <Link to={`/quotations/quotation/${row.quotationNumber}/${row._id}?type=preview&download`} disabled={!screenAccess}>
              <p style={darkMode ? { color: "white" } : { color: "black" }} >
                <TimelineItem color="#87CEEB"
                  icon={<DownloadIcon className="actionicon" />}
                  title="Download Invoice"
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preview/Download</p>
            </Link>
          </Grid>
          <Grid >
            {row.createInvoiceAvailable ?
              <p onClick={() => { handleCreateInvoice(row._id, row.quotationNumber) }} disabled={!screenAccess}><TimelineItem color="success"
                icon={<ReceiptIcon className="actionicon" />}
                title="Create Invoice" onClick={() => { handleCreateInvoice(row._id, row.quotationNumber) }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Create Invoice</p>

              : <p style={{ cursor: 'not-allowed' }} disabled={!screenAccess}>
                <TimelineItem color="grey"
                  icon={<ReceiptIcon className="actionicon" />}
                  title=" Create Invoice" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Create Invoice</p>

            }</Grid>

        </>
      } />,
    },
  ];

  const handleAddNew = () => {
    if (!screenAccess) {
      showResMsg(genericMessage.notPermission, 2000, false);
    } else {

      navigate("/quotations/add?type=new");

    }
  }

  var dropicons = document.querySelectorAll('.MuiInputBase-root');
  for (let i = 0; i < dropicons.length; i++) {
    var svgicon = dropicons[i].getElementsByTagName('svg');
    if (svgicon.length > 0) {
      if (darkMode) {
        svgicon[0].setAttribute("style", "fill: white !important;");
      } else {
        svgicon[0].setAttribute("style", "fill:");
      }
    }
  }

  //Optimized Component for Search Field 
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues(prevValues => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchQuotations();
  }, [values.filterValues]);
  useEffect(() => {
    if (resetClicked) {
      fetchQuotations();
      setResetClicked(false);
    }

  }, [resetClicked]);
  const handleRefreshButtonClick = () => {
    // fetchQuotations();
    setValues((prevValues) => ({
      ...prevValues,
      sortingType: "",
      sortingField: "",
      quotationStatus: "All",
      activityStatus: "All",
      durationDate: "",
      fromDate: "",
      toDate: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sendEmailFlag: false,
      filterValues: "",
      searchParameterList: ['quotationNumber', 'activityStatus', 'quotationStatus', 'createdInvoice', 'quotationDate', 'customerName',
        'finalAmount', 'lastEmailSentDate', 'customerCompanyName'],
    }));
    setResetClicked(true);
  }
  console.log(" values", values.filterValues);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary" >
          <PageTitle screenName="Quotations" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2}  >
            <MDButton
              rel="noreferrer"
              variant="gradient"
              color="success"
              style={{ height: "38.11px !important" }}
              // fullWidth
              onClick={handleRefreshButtonClick}

            >
              <RefreshIcon color="light" sx={{ cursor: "pointer" }} />
            </MDButton>
            <Grid lg={1.5} xs={6} >

              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.quotationStatus}
                  onChange={(e) => setValues({ ...values, quotationStatus: e.target.value })}

                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={1.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Activity Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Activity Status"
                  value={values.activityStatus}
                  onChange={(e) => setValues({ ...values, activityStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Draft">Draft</MenuItem>
                  <MenuItem value="Viewed">Viewed</MenuItem>
                  <MenuItem value="Sent">Sent</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              />
              {/* <TextField
                fullWidth
                id="standard-bare"
                variant="outlined"
                className="searchButton"
                placeholder="Search..."

                label="Search Filter"
                defaultValue="How can we help"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchQuotations();
                }}
                InputProps={{
                  endAdornment: (
                    <CustomIconButton size="small" tableBorder={tableBorder}  darkMode={darkMode}>

                      <GridSearchIcon />
                    </CustomIconButton>
                  ),
                }}
              /> */}
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <MDButton
                variant="contained"
                color="success"
                style={{ height: "38.11px" }}
                className={(!screenAccess ? (darkMode ? "disabledInDarkMode" : "disabledInLightMode") : "")}
                onClick={handleAddNew}>
                Add New
              </MDButton>
            </div>
          </Grid>

          <BTable
            columns={columns}
            data={rows}
            sortServer
            sortingType={handleSort}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        </Card>
      </div>
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <BillingModal
        open={showBillingModal}
        handleConfirm={() => { navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />
      <LoadingModal loading={loading} />
      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
    </DashboardLayout>
  );
}
export default memo(QuotaionsSearch);
